var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"label":"Empleado","loading":_vm.isLoading,"items":_vm.employees,"item-text":"fullName","return-object":"","required":""},model:{value:(_vm.selectedEmployee),callback:function ($$v) {_vm.selectedEmployee=$$v},expression:"selectedEmployee"}})
}
var staticRenderFns = []

export { render, staticRenderFns }